import { getPatientList } from '@/apis/fromBaseApi/patient.js'
import { getHosAreaDetail } from '@/apis/fromBaseApi/hospital_area_list.js'
const state = {
  hasMore: false,
  go_top_show: false // 返回顶部显示
}
let host = ''
if (window.location.hostname.indexOf('appv3.ynhdkc.com') > -1) {
  host = 'https://newdytapi.ynhdkc.com'
} else {
  host = 'https://newdytapi.ynhdkc.com'
}
const actions = {
  loadList({ commit }, args) {
    let url = ''
    switch (args.type) {
      // 预约挂号相关
      case 'registration_unpay_list': // 获取就诊人列表
        url = `/v1/mz/unpaylist?hos_code=${args.hos_id}&pat_id=${args.pat_id}`
        break
      case 'registration_hospital_list': // 获取医院列表
        url = `/v1/hospital`
        break
      case 'registration_report_list': // 获取检查检验报告列表
        if (args.reportType === 1) {
          // 检查报告
          url = `/v1/jc?hos_code=${args.hos_id}&jz_card=${args.jz_card}&start_date=${args.start_date}&end_date=${args.end_date}&patient_id=${args.patient_id}`
        } else if (args.reportType === 0) {
          // 检验报告
          url = `/v1/jy?hos_code=${args.hos_id}&jz_card=${args.jz_card}&start_date=${args.start_date}&end_date=${args.end_date}&patient_id=${args.patient_id}`
        }
        break
      // 智能导诊相关列表
      case 'guidance_doclist': // 获取导诊医生全部列表
        if (args.page) {
          url = `/symptom/recomdoctor/docListBykeyWords?user_id=${args.user_id}&hos_id=${args.hos_id}&dep_id=${args.dep_id}&doc_name=${args.doc_name}&page=${args.page}&page_num=10`
        } else {
          url = `/symptom/recomdoctor/getRecomdocLists?user_id=${args.user_id}`
        }
        break
      case 'guidance_ABClist': // 获取字母病症列表
        url = `/symptom/disease/diseaseListsBychar?char=${args.letter}&page=${args.page}&page_num=${args.page_num}`
        break
      // 在线问诊相关列表
      case 'ask_doc_group_recommend': // 获取医师团队推荐列表
        url = `/ask2/doctorgroup?page=${args.page}`
        break
      case 'ask_active_group': // 活跃医师
        url = `/ask2/doctorgroup?def_sort=5&page=${args.page}`
        break
      case 'ask_myfollow_group': // 获取我关注的医师列表
        url = `/ask2/myfollowgroup?page=${args.page}&follow_type=${args.followType}&user_id=${args.userId}`
        break
      case 'ask_myfollow_question': // 获取我围观的问题
        url = `/ask2/myfollowquestionV2?page=${args.page}&follow_type=${args.followType}&user_id=${args.userId}`
        break
      case 'ask_question_list': // 获取公开问题列表
        url = `/ask2/question?page=${args.page}&s_depart=${args.depId}&doctor_group_id=${args.doctorGroupId}&user_id=${args.user_id}`
        if (args.seled === 1) {
          url += `&seled=${args.seled}`
        }
        break
      case 'ask_comment_list': // 获取医师评价列表
        url = `/ask2/comment?page=${args.page}&page_num=${args.pageNum}&doctor_group_id=${args.doctorGroupId}&star=4,5&from=0`
        break
      case 'ask_doclist_for_dep': {
        // 获取某个科室的医师列表
        let filter = args.filter
        let sub = args.sub
        let isFree = args.isFree
        let keyword = args.keyword
        let departId = args.departId
        let Subdepart = args.Subdepart
        if (args.hospital_name && args.depart_name) {
          url = `/ask2/doctorgroup?hospital_name=${args.hospital_name}&depart_name=${args.depart_name}&page=${args.page}${
            !departId ? '' : '&s_depart=' + departId
          }${!filter ? '' : '&def_sort=' + filter}${!sub ? '' : '&hospital_code=' + sub}${!keyword ? '' : '&s_keyword=' + keyword}`
        } else if (args.Subdepart) {
          url = `/ask2/doctorgroup?page=${args.page}${!departId ? '' : '&s_depart=' + departId}${!Subdepart ? '' : '&s_subdepart=' + Subdepart}${
            !sub ? '' : '&hospital_code=' + sub
          }${!keyword ? '' : '&s_keyword=' + keyword}`
        } else {
          url = `/ask2/doctorgroup?page=${args.page}${!departId ? '' : '&s_depart=' + departId}${!filter ? '' : '&def_sort=' + filter}${
            !sub ? '' : '&hospital_code=' + sub
          }${!keyword ? '' : '&s_keyword=' + keyword}`
        }
        if (isFree) {
          url += `&&free_clinic=1`
        }
        let source = sessionStorage.getItem('fromCsfw')
        if (source === 'kunhua') {
          url += `&channel=kunhua`
        }
        break
      }
      case 'ask_tel_schedules': // 获取电话问诊排班
        url = `/ask2/telschedule?doctor_id=${args.doctorId}`
        break
      // 个人中心相关列表
      case 'ucenter_address_list': // 获取就诊人列表
        url = `/ucenter/address?user_id=${args.userId}`
        break
      // 个人中心相关列表
      case 'ucenter_patient_list': // 获取就诊人列表
        url = `/index/patient/${args.userId}?hos_id=${args.hosId ? args.hosId : ''}`
        break
      case 'ucenter_patient_list_new': // 获取就诊人列表
        url = 'getPatientList'

        break
      case 'ucenter_my_follow_doctors': // 获取我关注的医师列表
        url = `${host}/index/favorite/getList?type=${args.followType ? args.followType : '2_3'}&page=${args.page}`
        break
      case 'ucenter_my_follow_hospitals': // 获取我关注的医院列表
        url = `${host}/index/favorite/getList?type=1&page=${args.page}`
        break
      default:
        return Promise.reject(new Error('请求参数异常' + args.type))
    }
    return new Promise((resolve, reject) => {
      if (url == 'getPatientList') {
        getPatientList({ current_page: 1, page_size: 50 }).then((res) => {
          commit({
            type: 'setList',
            dataType: args.type,
            data: res.data.list,
            module: args.module,
            page: args.page
          })

          resolve(res.data.list)
        })
      } else if (url.indexOf('/index/patient') > -1) {
        window.newDytApiBaseApi
          .get(url)
          .then((res) => {
            res && res.data && res.data.code === 1
              ? (() => {
                  commit({
                    type: 'setList',
                    dataType: args.type,
                    data: res.data.data,
                    module: args.module,
                    page: args.page
                  })
                })()
              : commit({
                  type: 'setList',
                  dataType: args.type,
                  module: args.module,
                  data: [],
                  page: args.page
                })
            if (res && res.data) {
              resolve(res.data)
            }
          })
          .catch((e) => {
            reject(e)
          })
      } else {
        window.axiosBaseApi
          .get(url)
          .then((res) => {
            res && res.data && res.data.code === 1
              ? (() => {
                  commit({
                    type: 'setList',
                    dataType: args.type,
                    data: res.data.data,
                    module: args.module,
                    page: args.page
                  })
                })()
              : commit({
                  type: 'setList',
                  dataType: args.type,
                  module: args.module,
                  data: [],
                  page: args.page
                })
            if (res && res.data) {
              resolve(res.data)
            }
          })
          .catch((e) => {
            reject(e)
          })
      }
    })
  },
  loadDetail({ commit }, args) {
    let url = ''
    switch (args.type) {
      // 预约挂号相关详情
      case 'registration_unpay_item': // 在线缴费项目详情
        url = `/v1/mz/unpaylist/${args.bill_id}?hos_code=${args.hos_id}&pat_id=${args.pat_id}&total_price=${args.price}`
        break
      case 'registration_hospital_detail': // 医院详情
        url = `${host}/index/hospital/${args.hos_id}?require_info=${args.require_info ? args.require_info : ''}`
        break
      case 'registration_hospital_detail_new': // 医院详情
        url = `registration_hospital_detail_new`
        break
      case 'registration_report_detail': // 检验检查报告详情
        if (args.reportType === 0) {
          // 检查报告
          url = `/v1/jc/1?hos_code=${args.hos_id}&jz_card=${args.jz_card}&report_id=${args.report_id}`
        } else if (args.reportType === 1) {
          // 检验报告
          url = `/v1/jy/1?hos_code=${args.hos_id}&jz_card=${args.jz_card}&report_id=${args.report_id}`
        }
        break
      case 'registration_floor': // 楼层分布
        url = `/v1/floor?hos_code=${args.hos_id}`
        break
      case 'registration_stop': // 停诊通知
        url = `/v1/doctorstop?hos_code=${args.hos_id}`
        break
      // 在线问诊相关详细
      case 'ask_doctor_detail': // 获取医师详情
        url = `/ask2/doctorgroup/${args.doctorId}?user_id=${args.userId}`
        break
      case 'ask_question_detail': // 获取问题详情
        url = `/ask2/question/${args.questionId}?user_id=${args.userId}&page_num=30`
        break
      case 'ask_comment_detail': // 获取评论详情
        url = `/ask2/comment/${args.commentId}`
        break
      // 加班门诊相关详情
      case 'doctor_overtimeclinic_index': // 获取医生详情
        url = `/plus-registration/pat/api/v1/doctor/228`
        break
      default:
        return Promise.reject(new Error('请求参数异常'))
    }
    return new Promise((resolve, reject) => {
      if (url == 'registration_hospital_detail_new') {
        getHosAreaDetail({
          hospital_area_id: args.hospital_area_id,
          hospital_area_code: args.hos_id
        }).then((res) => {
          if (res.status == 200) {
            commit({
              type: 'setDetail',
              dataType: args.type,
              data: res.data,
              module: args.module
            })
          }
          resolve(res.data)
        })
        return
      }
      window.axiosBaseApi
        .get(url)
        .then((res) => {
          console.log(res)
          if (res && res.data && res.data.code === 1) {
            // oss拼接参数
            if (args.type === 'ask_question_detail') {
              let askDuestionDetail = res.data.data
              // 患者追问
              let questionsFlag = 0
              for (let j = 0; j < askDuestionDetail.questions_log.length; j++) {
                if (askDuestionDetail.questions_log[j].imgs.length !== 0) {
                  questionsFlag = 1
                }
              }
              if (questionsFlag || (askDuestionDetail.symptom_info_imgs && askDuestionDetail.symptom_info_imgs.length !== 0)) {
                let url =
                  'https://1487726325366913.cn-shenzhen.fc.aliyuncs.com/2016-08-15/proxy/OSS_Token/oss_download_sign/?bucket_name=inquiry-ol&file_name=""'
                if (askDuestionDetail.symptom_info_imgs && askDuestionDetail.symptom_info_imgs.length !== 0) {
                  for (let i = 0; i < askDuestionDetail.symptom_info_imgs.length; i++) {
                    if (askDuestionDetail.symptom_info_imgs[i].substr(0, 1) === '/') {
                      let length = askDuestionDetail.symptom_info_imgs[i].length
                      askDuestionDetail.symptom_info_imgs[i] = askDuestionDetail.symptom_info_imgs[i].substr(1, length)
                    }
                    url += `&file_name=${askDuestionDetail.symptom_info_imgs[i]}`
                  }
                }
                window.axiosBaseApi
                  .get(url)
                  .then(function (ress) {
                    if (ress.status === 200) {
                      let imgUrl = []
                      for (let k = 0; k < ress.data.signs.length; k++) {
                        if (ress.data.signs[k].key !== '""') {
                          imgUrl.push(
                            `https://inquiry.ynhdkc.com/${ress.data.signs[k].key}?Expires=${ress.data.time_stamp}&OSSAccessKeyId=${ress.data.accessKeyId}&Signature=${ress.data.signs[k].sign}`
                          )
                        }
                      }
                      if (imgUrl.length !== 0) {
                        askDuestionDetail.symptom_info_imgs = imgUrl
                      }
                      // 医生回复
                      if (askDuestionDetail.questions_log && askDuestionDetail.questions_log.length !== 0) {
                        url =
                          'https://1487726325366913.cn-shenzhen.fc.aliyuncs.com/2016-08-15/proxy/OSS_Token/oss_download_sign/?bucket_name=inquiry-ol'
                        for (let j = 0; j < askDuestionDetail.questions_log.length; j++) {
                          if (askDuestionDetail.questions_log[j].imgs.length !== 0) {
                            for (let p = 0; p < askDuestionDetail.questions_log[j].imgs.length; p++) {
                              url += `&file_name=${askDuestionDetail.questions_log[j].imgs[p]}`
                            }
                          } else {
                            url += `&file_name=''`
                          }
                        }
                        window.axiosBaseApi
                          .get(url)
                          .then(function (ret) {
                            if (ret.status === 200) {
                              imgUrl = []
                              for (let r = 0; r < ret.data.signs.length; r++) {
                                if (ret.data.signs[r].key !== "''") {
                                  imgUrl.push(
                                    `https://inquiry.ynhdkc.com/${ret.data.signs[r].key}?Expires=${ret.data.time_stamp}&OSSAccessKeyId=${ret.data.accessKeyId}&Signature=${ret.data.signs[r].sign}`
                                  )
                                }
                              }
                              for (let j = 0; j < askDuestionDetail.questions_log.length; j++) {
                                if (
                                  askDuestionDetail.questions_log[j].imgs.length !== 0 &&
                                  askDuestionDetail.questions_log[j].imgs[0].indexOf('file') > -1
                                ) {
                                  let length = askDuestionDetail.questions_log[j].imgs.length
                                  if (length > 1) {
                                    askDuestionDetail.questions_log[j].imgs = imgUrl.slice(0, length)
                                    imgUrl.splice(0, length)
                                  } else {
                                    askDuestionDetail.questions_log[j].imgs = imgUrl.slice(0, 1)
                                    imgUrl.splice(0, 1)
                                  }
                                }
                              }
                              commit({
                                type: 'setDetail',
                                dataType: args.type,
                                module: args.module,
                                data: askDuestionDetail
                              })
                            } else {
                              alert(ress.statusText)
                            }
                          })
                          .catch((e) => {
                            alert(e)
                          })
                      } else {
                        commit({
                          type: 'setDetail',
                          dataType: args.type,
                          module: args.module,
                          data: askDuestionDetail
                        })
                      }
                    } else {
                      alert(ress.statusText)
                    }
                  })
                  .catch((e) => {
                    alert(e)
                  })
              } else {
                commit({
                  type: 'setDetail',
                  dataType: args.type,
                  module: args.module,
                  data: res.data.data
                })
              }
            } else {
              commit({
                type: 'setDetail',
                dataType: args.type,
                module: args.module,
                data: res.data.data
              })
            }
          } else if (res && res.data && res.data.code === 0) {
            commit({
              type: 'setDetail',
              dataType: args.type,
              module: args.module,
              data: {}
            })
          }

          if (res && res.data) {
            resolve(res.data)
          }
        })
        .catch((e) => {
          reject(e)
        })
    })
  }
}

const mutations = {
  change_go_top_show(state, flag) {
    state.go_top_show = flag
  },
  setData(state, args) {
    if (args.module) {
      state[args.module][args.dataType] = args.data
    } else {
      state[args.dataType] = args.data
    }
  },
  setList(state, args) {
    if (args.dataType == 'ask_question_list') {
      args.data.forEach((item) => {
        let createDate = new Date(item.create_time * 1000)
        let now = new Date()
        let diffTime = now - createDate // 时间差，以毫秒为单位
        let diffDays = diffTime / (1000 * 60 * 60 * 24) // 将时间差转换为天数
        let isOverSevenDays = diffDays > 7
        if ((item.status == '3' && isOverSevenDays) || item.status == '-1' || item.status == '-2') {
          item.candelete = true
        } else {
          item.candelete = false
        }
      })
    }
    if (args.dataType === 'ask_comment_list' && args.data.list) {
      state.ask.ask_comment_count = args.data.count
      args.data = args.data.list
    }
    if (args.data && args.data.length) {
      args.data.length < 10 ? (state.hasMore = false) : (state.hasMore = true)
    } else {
      if (args.page <= 1) {
        state[args.module][args.dataType] = []
      }
      state.hasMore = false
      return
    }
    if (args.page === 1) {
      if (args.data.length == 0) {
        state[args.module][args.dataType] = []
      } else {
        state[args.module][args.dataType] = args.data
      }
    } else {
      if (args.data.length > 0) {
        args.data.forEach((item) => {
          state[args.module][args.dataType].push(item)
        })
      }
    }
  },
  setDetail(state, args) {
    state[args.module][args.dataType] = args.data
  }
}

export default {
  state,
  actions,
  mutations
}
